const LayoutConstants = {
  headerHeight: 115,
};

export default LayoutConstants;
